module.exports = __webpack_public_path__ + "static/fonts/iconfont.34ea3475.34ea3475.woff";